import React from 'react';
import {FormattedMessage} from 'react-intl';
import {pathnames as P} from '../../../_common/constants/pathnames';
import {subjects as S} from '../../../_common/constants/permissionSubjects';
import AsideMenuLink from '../../../_common/components/Aside/AsideMenuLink';

const DashboardPageLink = () => {

  return (
    <AsideMenuLink
      pathname={P.DASHBOARD_PAGE}
      subject={S.DASHBOARD_PAGE}
      icon={'Layers_primary.svg'}
      label={<FormattedMessage id="dashboard-page-link" defaultMessage="Dashboard"/>}
    />
  );
};

export default DashboardPageLink;
